/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from "@glimmer/component";
import type Patient from "parog-web/models/patient";
import type { Signature as BaseCancerFormSignature } from "../../base-cancer-form";
import BaseCancerForm from "../../base-cancer-form";

interface Signature {
  Args: {
    form: BaseCancerFormSignature["Args"]["form"];
    patient: Patient;
  };
}

export default class MedicalHistoryFormCervixCancerDiagnosticFieldsComponent extends Component<Signature> {
  BaseCancerForm = BaseCancerForm;
}
